import { themeObject } from 'lib';

export const addItemCardStyles = {
    card: {
        flexGrow: 1,
        height: '220px',
        border: '2px dashed',
        borderColor: themeObject.palette.primary.dark,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        borderRadius: '5px',
        boxShadow: 'none',
        gap: '8px',
        cursor: 'pointer',
    },
    box: { display: 'flex', justifyContent: 'center' },
    image: {
        height: '100px',
        width: '100px',
    },
    cardActions: { p: 0 },
    button: {
        color: themeObject.palette.primary[700],
    },
    addIcon: {
        color: themeObject.palette.primary[500],
    },
};
